import { testimonials } from '@/mocks/homeData';

export default function Testimonials() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            ⭐ 用户口碑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            吃瓜群众<span className="text-accent-500">都说好</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-2">数百万忠实用户的选择与信赖</p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {/* Large featured card */}
          <div className="md:col-span-2 lg:col-span-1 lg:row-span-2 bg-background-50 rounded-2xl border border-secondary-200/60 p-5 md:p-6 flex flex-col justify-between">
            <div>
              <i className="ri-double-quotes-l text-4xl text-primary-200"></i>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mt-3 mb-6">
                {testimonials[0].quote}
              </p>
            </div>
            <div className="flex items-center gap-3 pt-4 border-t border-secondary-200/50">
              <img
                src={testimonials[0].avatar}
                alt={testimonials[0].name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <p className="text-foreground-900 text-sm font-semibold font-heading">{testimonials[0].name}</p>
                <p className="text-foreground-400 text-xs">{testimonials[0].role}</p>
              </div>
            </div>
          </div>

          {/* Remaining cards */}
          {testimonials.slice(1).map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-2xl border border-secondary-200/60 p-5 md:p-6 flex flex-col justify-between"
            >
              <div>
                <i className="ri-double-quotes-l text-3xl text-accent-200"></i>
                <p className="text-foreground-600 text-sm leading-relaxed mt-2 mb-4 line-clamp-4">
                  {t.quote}
                </p>
              </div>
              <div className="flex items-center gap-3 pt-3 border-t border-secondary-200/50">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-foreground-900 text-sm font-semibold font-heading">{t.name}</p>
                  <p className="text-foreground-400 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}